import { useState } from 'react'
import styles from './FAQ.module.scss'

export default function FAQ({ section }) {
  const [opened, setOpened] = useState([0])

  /**
   * Check if given FAQ is opened.
   */
  const isOpen = (id) => opened.includes(id)

  /**
   * Open or close individual faq.
   */
  const toggleFaq = (id) => {
    if (opened.includes(id)) {
      setOpened(opened.filter((faq) => faq !== id))
    } else {
      setOpened([...opened, id])
    }
  }

  const getFaqClasses = (id) => {
    if (isOpen(id)) {
      return `${styles.faq} ${styles.open}`
    }

    return styles.faq
  }

  return (
    <section className={styles.section} id="ukk">
      <h5 className={styles.title}>UKK</h5>
      {section.map((faq, index) => (
        <div
          className={getFaqClasses(index)}
          key={`faq-${index}`}
          onClick={() => toggleFaq(index)}
        >
          <p className={styles.question}>{faq.question}</p>

          {isOpen(index) && <p className={styles.answer}>{faq.answer}</p>}
        </div>
      ))}
    </section>
  )
}
